import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Collapse } from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import classname from "classnames"

//i18n
import { withTranslation, useTranslation } from "react-i18next"
import { connect } from "react-redux"

const Navbar = props => {
  const [dashboard, setdashboard] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    for (var i = 0; i < items.length; ++i) {
      if (props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  const customMenu = () => {
    const menuSession = sessionStorage.getItem("menu")
      ? JSON.parse(sessionStorage.getItem("menu"))
      : []
    return (
      <ul className="navbar-nav">
        <li className="nav-item dropdown" key="home">
          <Link to="/dashboard" className="nav-link dropdown-toggle arrow-none">
            <i className="bx bx-home me-2"></i>
            {t("menu:Starter Page")}
          </Link>
        </li>
        {menuSession.map(({ Nodes, menuId, name }) => (
          <li className="nav-item dropdown" key={menuId}>
            <Link
              to="/#"
              onClick={e => {
                e.preventDefault()
              }}
              className="nav-link dropdown-toggle arrow-none"
            >
              <i
                className={
                  name.toLowerCase().includes("config")
                    ? "bx bx-cog me-2"
                    : "bx bx-wifi-1 me-2"
                }
              ></i>
              {name}
              <div className="arrow-down"></div>
            </Link>
            <div className={classname("dropdown-menu", { show: dashboard })}>
              {Nodes.map(({ name, menuId, transaction }) => (
                 transaction?.route===""?null:
                <Link
                  to={transaction?.route}
                  className="dropdown-item"
                  key={menuId}
                >
                  {name}
                </Link>
              ))}
            </div>
          </li>
        ))}
      </ul>
    )
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              {customMenu()}
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
)
